import React from "react";
import { useHistory } from "react-router-dom";
import { Image } from "antd";
import TableBase from "../../../../components/table/TableBase";

const LocationsTable = ({ dataSource, pagination, loading = false }) => {
  const history = useHistory();

  const handleViewDetails = (record) => {
    history.push(`/locations/${record.id}`, { locationData: record });
  };

  const columns = [
    {
      title: "",
      dataIndex: "image",
      width: 80,
      render: (image) => {
        return (
          <div className="location-thumbnail">
            {image ? (
              <Image
                src={image}
                alt="Location"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "contain",
                  borderRadius: "6px"
                }}
                preview={false}
              />
            ) : (
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999"
                }}
              >
                📍
              </div>
            )}
          </div>
        );
      }
    },
    {
      title: "Location Details",
      dataIndex: "locationName",
      render: (value, record) => {
        return (
          <div className="location-details">
            <div className="location-name">{value}</div>
            <div className="location-address">
              {record.descriptiveAddress || record.address}
            </div>
          </div>
        );
      }
    },
    {
      title: "Coordinates & Address",
      width: 200,
      render: (_, record) => {
        return (
          <div className="coordinates-and-address">
            <div className="coordinates">
              {record.lat && record.lng
                ? `${parseFloat(record.lat).toFixed(6)}, ${parseFloat(record.lng).toFixed(
                    6
                  )}`
                : "N/A"}
            </div>
            <div className="map-address">{record.address || "N/A"}</div>
          </div>
        );
      }
    }
  ];

  return (
    <TableBase
      columns={columns}
      data={dataSource}
      pagination={pagination}
      loading={loading}
      rowKey="id"
      onRow={(record) => ({
        onClick: () => handleViewDetails(record),
        style: { cursor: "pointer" }
      })}
    />
  );
};

export default LocationsTable;
